import React from 'react';

class Emoticon extends React.Component {
	handleClick = (event) => {
	  event.preventDefault();
	  this.props.addEmoticon(this.props.shortname);
	};

	render() {
	  if (this.props.panel == true) {
	    return (
  <a href="#" className="emoticon" title={this.props.shortname} onClick={this.handleClick}>
    <div className="emoticon-wrap">
      <img src={this.props.spritePath} className={this.props.id} />
    </div>
  </a>
	    );
	  }

	  return (
  <img className="emojione" alt={this.props.alt} src={this.props.src} />
	  );
	}
}

module.exports = Emoticon;
